import {useState, useEffect} from 'react';

import DeleteProduct from '../../components/DeleteProduct';
export default function DeleteproductActionImpl(){

    return (
        <>
        <DeleteProduct/>
        </>
    )
}